export default ['toastr', '$q', '$rootScope', lazyWatcherService]

/*
 * The original plan was to use this in metaElement/directive.js. That fell through when I remebered
 *  I could utilize ng-init and ng-model in the same element.
 *
 * The objective of managing a number of watchers to perform a single option is tedious. This
 *  service was built to watch a controller scope for changes in $scope and then respond with a defer.resolve.
 *
 * After the initial resolve, the $watchers are destroyed.
 */
function lazyWatcherService(toastr, $q, $rootScope) {
  // We want to perform an action when a set of controller keys are finished being resolved.
  var service = {
    $watch: function(initKeys, controllerScope) {
      const defer = $q.defer()
      const localScope = $rootScope.$new(true)
      localScope.initKeys = []
      let idx = 0
      initKeys = initKeys.slice() // We don't want to be effected by state mutation.
      for (idx; idx < initKeys.length; idx++) {
        let initKey = initKeys[idx]
        controllerScope.$watch(initKey, function(newValue, oldValue) {
          if (newValue !== undefined) {
            localScope.initKeys.push({
              key: initKey,
              value: newValue,
            })
          }
        })
      }
      localScope.$watchCollection('initKeys', function(newValue, oldValue) {
        if (newValue !== undefined) {
          if (newValue.length === initKeys.length) {
            defer.resolve(
              newValue.reduce(function(acc, item, idx) {
                acc[item['key']] = item['value']
                return acc
              }, {})
            )
            // Avoid the evil $digest loop of DARTH.
            // https://github.com/angular/angular.js/issues/5658#issue-25154436
            localScope.$evalAsync(function() {
              localScope.$destroy()
            })
          }
        }
      })
      return defer.promise
    },
  }
  return service
}
